<template>
  <q-dialog ref="dialogRef" persistent @hide="onDialogHide">
    <q-card
      :style="{
        minWidth: '600px',
      }"
      class="relative-position elevation-1"
    >
      <q-card-section
        class="flex justify-between items-center q-px-2x-md q-py-xl"
      >
        <span class="text-lg text-neutral text-weight-medium">
          Send Report for Approval
        </span>

        <PBtn flat dense round size="sm" @click="() => onDialogCancel()">
          <CloseIcon class="icon" />
        </PBtn>
      </q-card-section>

      <q-separator></q-separator>

      <q-card-section
        class="rounded-borders text-neutral-90 text-center q-px-2x-md q-py-xl"
      >
        <q-form @submit="onSubmit">
          <PSelectInput
            v-model="formData.approvers"
            label="Select Approvers"
            placeholder="Select name"
            help="Select someone who is responsible for this approval"
            help-classes="text-xs text-neutral-70 q-mb-xs flex"
            :options="unref(kamFilter.entities)"
            :options-loading="unref(kamFilter.loading)"
            option-label="name"
            option-value="_id"
            required
            multiple
            use-chips
            @virtual-scroll="kamFilter.onScroll"
            @filter="kamFilter.onFilter"
            @filter-abort="kamFilter.onAbortFilter"
          />
          <PInput
            v-model="formData.remarks"
            type="textarea"
            label="Remarks"
            placeholder="Enter comment"
          />
          <div class="flex justify-end q-mt-xl">
            <PBtn
              :fluid="false"
              :loading="isLoading"
              label="Submit"
              type="submit"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { useDialogPluginComponent } from "quasar";

import CloseIcon from "assets/icons/close.svg";
import { unref } from "vue";

defineEmits([...useDialogPluginComponent.emits]);

const { putUserCreditReportForApproval } = useUserStore();

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent();

const isLoading = ref(false);

const props = defineProps({
  creditSummary: {
    type: Object,
    default: () => ({}),
  },
});

const formData = ref({
  approvers: null,
  remarks: "",
});

const kamFilter = useFilter({
  entity: "user",
  options: {
    params: {
      isActive: 1,
      roles: "kam",
      sortBy: "name",
      orderBy: "asc",
    },
  },
});

const onSubmit = async () => {
  try {
    isLoading.value = true;

    await putUserCreditReportForApproval({
      stage_cd: "send_for_approval",
      approvers: unref(formData).approvers,
      remarks: unref(formData).remarks,
      status_cd: "awaiting_approval",
      credit_summary: unref(props).creditSummary,
    });

    onDialogOK();
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};
</script>
